var map = {
	"./Logo.svg": 2,
	"./add.svg": 3,
	"./additional-bed.svg": 4,
	"./armchair.svg": 5,
	"./arrow-back.svg": 6,
	"./arrow-dropdown.svg": 7,
	"./arrow-left.svg": 8,
	"./arrow-right.svg": 9,
	"./arrow-slider-left.svg": 10,
	"./arrow-slider-right.svg": 11,
	"./arrow.svg": 12,
	"./bathroom.svg": 13,
	"./bell.svg": 14,
	"./booking.svg": 15,
	"./career.svg": 16,
	"./chat.svg": 17,
	"./check-green.svg": 18,
	"./check-white.svg": 19,
	"./close.svg": 20,
	"./date.svg": 21,
	"./download.svg": 22,
	"./dropdown-arrow.svg": 23,
	"./facebook.svg": 24,
	"./family.svg": 25,
	"./filter.svg": 26,
	"./gift-box.svg": 27,
	"./guests.svg": 28,
	"./heart-active.svg": 29,
	"./heart.svg": 30,
	"./house.svg": 31,
	"./info-tooltip.svg": 32,
	"./instagram.svg": 33,
	"./left.svg": 34,
	"./location.svg": 35,
	"./mail.svg": 36,
	"./menu-close.svg": 37,
	"./menu-waves.svg": 38,
	"./minus.svg": 39,
	"./phone-small.svg": 40,
	"./phone.svg": 41,
	"./plus.svg": 42,
	"./quote.svg": 43,
	"./remove.svg": 44,
	"./room-compare-large.svg": 45,
	"./room-compare.svg": 46,
	"./room-size.svg": 47,
	"./room-tag.svg": 48,
	"./sample.svg": 49,
	"./single-person.svg": 50,
	"./view-off.svg": 51,
	"./view.svg": 52,
	"./wave-rectangle.svg": 53,
	"./wave-square-full-opacity.svg": 54,
	"./wave-square.svg": 55,
	"./wave.svg": 56,
	"./waves-with-fill-low-opacity.svg": 57,
	"./waves-with-fill.svg": 58
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1;